<script setup>
import { Modal } from '@drama/ui'

defineProps({
  open: { type: Boolean, default: false },
  capability: { type: String, required: true },
  title: { type: String, required: true },
  url: { type: String, required: true },
})
const emit = defineEmits(['update:open'])
</script>

<template>
  <Modal
    :open="open"
    :title="title"
    width="1120px"
    @update:open="emit('update:open', $event)"
  >
    <div class="media-preview">
      <img v-if="capability === 'image'" :src="url" :alt="title" />
      <video v-else-if="capability === 'video'" :src="url" controls autoplay playsinline preload="metadata" />
      <audio v-else-if="capability === 'tts'" :src="url" controls autoplay preload="metadata" />
    </div>
  </Modal>
</template>

<style scoped lang="scss">
.media-preview {
  display: grid;
  place-items: center;
  min-height: 240px;
  border-radius: var(--drama-radius-md);
  background: var(--drama-color-bg);
  overflow: hidden;

  img,
  video {
    display: block;
    width: 100%;
    max-height: calc(90vh - 180px);
    object-fit: contain;
  }

  audio {
    width: min(720px, calc(100% - var(--drama-space-xl) * 2));
    margin: var(--drama-space-2xl) auto;
  }
}
</style>
